export default __webpack_public_path__ + "static/media/annihilate.68d81d62.png";